export default __webpack_public_path__ + "static/media/g2022-28.0c5e3c06.jpeg";